import { AdditionalBookingSectionEntity, IAdditionalBookingSectionEntityAttributes } from '../../../Models/Entities';
import axios from 'axios';
import { ADDITIONAL_OPTION_ENTITY_URL } from 'Constants';
import { buildUrl } from '../../../Util/FetchUtils';

export async function getAllAdditionalOptionSections(userId: string | null): Promise<AdditionalBookingSectionEntity[]> {
	const response = await axios.get(
		buildUrl(`${ADDITIONAL_OPTION_ENTITY_URL}/get-all-additional-option-sections`, { userId: userId ?? 'null' }),
	);

	return response.data.map(
		(x: Partial<IAdditionalBookingSectionEntityAttributes>) => new AdditionalBookingSectionEntity(x),
	);
}
